import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Photowalk #2",
  "description": "",
  "published": "2008-12-07T00:00:00.000Z",
  "redirect_from": ["/blog/photowalk-2/swizec/33"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last week I took `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/my-first-weekly-photowalk/2/395"
      }}>{`my first photowalk`}</a>{` and was instantly hooked. Well, today I managed taking another one and have incorporated many of the lessons I learned last time - namely not to overexpose so much if I want to retain some semblance of night-time and since I still don't have a tripod I tried resting the camera on anything I could find rather than pretend I was superman.`}</p>
    <p>{`Christmas decoration Ljubljana was lovely, I've always loved walking in decorated cities, but Ljubljana takes the cake. I believe we're the only city in the world with sperm and DNA as christmas decorations ... anyway, this year we have a new mayor and I've noticed a great improvement. Instead of just a single street being full of money wasters we now have that same street, plus two squares and another street full of money wasters and party time. This is mostly benefactory to those of us who don't like very tight crowds and the people now spread over a larger area. Also the classical music that used to only play on one street - the oldest in Ljubljana - now plays in the whole strict city center.`}</p>
    <p>{`Here are the photos, hope you enjoy them.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      